import React, { useContext } from "react";
import LanguageContext from "../../components/Language/LanguageContext";

const Benefit = () => {
  const { language, messages, changeLanguage } = useContext(LanguageContext);
  return (
    <>
      {/* slide1 */}
      <div
        className="surface px-4 py-8 md:px-6 lg:px-8"
        id="benefit"
        style={{ backgroundColor: "white" }}
      >
        <div
          className="text-5xl font-bold text-center md:text-center smart"
          style={{
            color: "#013473",
            fontFamily: "Inter",
            marginBottom: "60px",
          }}
        >
          {messages.Featured}
        </div>
        <div className="grid ">
          <div className="col-12 md:col-6">
            <img
              src="/images/Benefit/Benefit.png"
              alt="Image"
              className="w-full"
              style={{ borderRadius: "30px 30px 30px 30px", marginTop: "40px" }}
            />
          </div>
          <div className="col-12 md:col-6 p-2 text-center md:text-left flex align-items-center ">
            <section>
              <span
                className="block text-4xl font-bold mb-3 text-900 text-center"
                style={{ fontFamily: "Inter" }}
              >
                {messages.featuredAnakJudul1} <hr />
              </span>
              <div
                className="text-xl mb-3 "
                style={{ fontFamily: "Poppins", color:'#1170c4' }}
              >
                {messages.accordionJudul1}
              </div>
              <p className="mt-1 mb-4 text-900 line-height-3 font-semibold">
                {messages.accordionAnak1}
              </p>
              <div
                className="text-xl mb-3"
                style={{ fontFamily: "Inter",color:'#1170c4' }}
              >
                {messages.accordionJudul2}
              </div>
              <p className="mt-1 mb-4 text-900 line-height-3 font-semibold">
                {messages.accordionAnak2}
              </p>
              <div
                className="text-xl mb-3 "
                style={{ fontFamily: "Inter",color:'#1170c4' }}
              >
                {messages.accordionJudul3}
              </div>
              <p className="mt-1 mb-4 text-900 line-height-3 font-semibold">
                {messages.accordionAnak3}
              </p>
            </section>
          </div>
        </div>
      </div>

      {/* slide 2 */}
      <div
        className="surface px-4 py-8 md:px-6 lg:px-8"
        id="benefit"
        style={{ backgroundColor: "white", marginTop: "-150px" }}
      >
        <div className="grid ">
          <div className="col-12 md:col-6 p-2 text-center md:text-left flex align-items-center ">
            <section>
              <span
                className="block text-4xl font-bold mb-3 text-900"
                style={{ fontFamily: "Inter" }}
              >
                {messages.featuredAnakJudul} <hr />
              </span>
              <div
                className="text-2xl  mb-3"
                style={{ fontFamily: "Inter",color:'#1170c4' }}
              >
                {messages.accordionJudul}
              </div>
              <p className="mt-1 mb-4 text-800 line-height-3 font-semibold">
                {messages.accordionAnak}
              </p>
            </section>
          </div>
          <div className="col-12 md:col-6">
            <img
              src="/images/Benefit/Benefit-3.png"
              alt="Image"
              className="w-full"
              style={{ borderRadius: "30px 30px 30px 30px", marginTop: "40px" }}
            />
          </div>
        </div>
      </div>

      {/* slide 3 */}
      <div
        className="surface px-4 py-8 md:px-6 lg:px-8 pt-n8"
        id="benefit"
        style={{ backgroundColor: "white", marginTop: "-150px" }}
      >
        <div className="grid ">
          <div className="col-12 md:col-6">
            <img
              src="/images/Benefit/Benefit-4.png"
              alt="Image"
              className="w-full"
              style={{ borderRadius: "30px 30px 30px 30px", marginTop: "40px" }}
            />
          </div>
          <div className="col-12 md:col-6 p-2 text-center md:text-left flex align-items-center ">
            <section>
              <span
                className="block text-4xl font-bold mb-3 text-900 text-center"
                style={{ fontFamily: "Inter" }}
              >
                {messages.featuredAnakJudul2} <hr />
              </span>
              <div
                className="text-xl  mb-3 "
                style={{ fontFamily: "Poppins",color:'#1170c4' }}
              >
                {messages.accordionJudul4}
              </div>
              <p className="mt-1 mb-4 text-900 line-height-3 font-semibold">
                {messages.accordionAnak4}
              </p>
            </section>
          </div>
        </div>
      </div>

      {/* slide4 */}
      <div
        className="surface px-4 py-8 md:px-6 lg:px-8"
        id="benefit"
        style={{ backgroundColor: "white", marginTop: "-150px" }}
      >
        <div className="grid ">
          <div className="col-12 md:col-6 p-2 text-center md:text-left flex align-items-center ">
            <section>
              <span
                className="block text-4xl font-bold mb-3 text-900 text-center"
                style={{ fontFamily: "Inter" }}
              >
                {messages.featuredAnakJudul3} <hr />
              </span>
              <div
                className="text-2xl  mb-3"
                style={{ fontFamily: "Inter",color:'#1170c4' }}
              >
                {messages.accordionJudul5}
              </div>
              <p className="mt-1 mb-4 text-800 line-height-3 font-semibold">
                {messages.accordionAnak5}
              </p>
              <div
                className="text-2xl  mb-3"
                style={{ fontFamily: "Inter",color:'#1170c4' }}
              >
                {messages.accordionJudul6}
              </div>
              <p className="mt-1 mb-4 text-800 line-height-3 font-semibold">
                {messages.accordionAnak6}
              </p>
            </section>
          </div>
          <div className="col-12 md:col-6">
            <img
              src="/images/Benefit/Benefit-5.png"
              alt="Image"
              className="w-full"
              style={{ borderRadius: "30px 30px 30px 30px", marginTop: "40px" }}
            />
          </div>
        </div>
      </div>

      {/* slide5 */}
      <div
        className="surface px-4 py-8 md:px-6 lg:px-8 pt-n8"
        id="benefit"
        style={{ backgroundColor: "white", marginTop: "-120px" }}
      >
        <div className="grid ">
          <div className="col-12 md:col-6">
            <img
              src="/images/Benefit/Benefit-6.png"
              alt="Image"
              className="w-full"
              style={{ borderRadius: "30px 30px 30px 30px", marginTop: "40px" }}
            />
          </div>
          <div className="col-12 md:col-6 p-2 text-center md:text-left flex align-items-center ">
            <section>
              <span
                className="block text-4xl font-bold mb-3 text-900 text-center"
                style={{ fontFamily: "Inter" }}
              >
                {messages.featuredAnakJudul4} <hr />
              </span>
              <div
                className="text-xl  mb-3 "
                style={{ fontFamily: "Poppins",color:'#1170c4' }}
              >
                {messages.accordionJudul7}
              </div>
              <p className="mt-1 mb-4 text-900 line-height-3 font-semibold">
                {messages.accordionAnak7}
              </p>
              <div
                className="text-xl  mb-3 "
                style={{ fontFamily: "Poppins",color:'#1170c4' }}
              >
                {messages.accordionJudul8}
              </div>
              <p className="mt-1 mb-4 text-900 line-height-3 font-semibold">
                {messages.accordionAnak8}
              </p>
              <div
                className="text-xl  mb-3 "
                style={{ fontFamily: "Poppins",color:'#1170c4' }}
              >
                {messages.accordionJudul9}
              </div>
              <p className="mt-1 mb-4 text-900 line-height-3 font-semibold">
                {messages.accordionAnak9}
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Benefit;
